import { ComingSoon } from '../shared/ComingSoon';

// The loan officer's workspace: their clients, invites, stages and section switches
export function LoanOfficerHome() {
  return (
    <ComingSoon title="Loan officer sign-in">
      Sign-in is coming next: Sign in with Microsoft, with email and password as a backup.
    </ComingSoon>
  );
}
